import React from "react";
import { MarkerType } from "react-flow-renderer";

import { Link } from "react-router-dom";

const level1 = "rgb(17,3,3, 0.1)";
const level2 = "#5d1c53";
const level3 = "rgb(20,28,39, 0.9)";
const level4 = "#3c5475";
const level5 = "#4517d1";
const level6 = "#de723a";
const black = "yellow";
const white = "white";
const transparent = "00FFFFFF";
const spaceColor = "#141c26";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Pseudo-classes</strong>
          <p>
            A CSS pseudo-class is a keyword added to a selector that specifies a
            special state of the selected element(s).
          </p>

          <p>
            Pseudo-classes let you apply a style to an element not only in
            relation to the content of the document tree, but also in relation
            to external factors like the history of the navigator (:visited, for
            example), the status of its content (like :checked on certain form
            elements), or the position of the mouse (like :hover, which lets you
            know if the mouse is over an element or not).
          </p>

          <p>
            Note: I only listed the Pseudo-classes I felt were most important to
            learn.{" "}
          </p>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>:active</strong>
          <p>Can be used to style any element on click. </p>
          <p>The link below will have a yellow background when clicked.</p>
          <Link className="link-to-pseudoclasses" to="/pseudoclasses">
            Pseudo-classes
          </Link>
          <p>
            {`a:active{
                background-color: yellow;
            }`}
          </p>
        </>
      ),
    },
    position: { x: 3323, y: 1100 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>:checked</strong>
          <p>
            Matches every checked {`<input>`} element (only for radio buttons
            and checkboxes) and {`<option>`} element.
          </p>
          <p>
            <iframe
              height="600"
              width="100%"
              scrolling="no"
              title=":checked"
              src="https://codepen.io/jonathanelias1/embed/preview/wvjeaZG?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/wvjeaZG">
                :checked
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: 1090, y: 3610 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>:enabled & :disabled</strong>
          <p>
            :enabled= Matches every enabled element
            <br />
            <br />
            :disabled= Matches every disabled element
            <br />
            <br />
            Both are mostly used on form elements
          </p>

          <p>
            <iframe
              height="600"
              width="100%"
              scrolling="no"
              title=":checked"
              src="https://codepen.io/jonathanelias1/embed/preview/wvjeKBz?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/wvjeKBz">
                :checked
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: 178, y: 3610 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "5",

    data: {
      label: (
        <>
          <strong>:empty</strong>
          <p>
            Matches every element that has no children (including text nodes).
          </p>

          <p>
            <iframe
              height="500"
              width="100%"
              scrolling="no"
              title=":disabled"
              src="https://codepen.io/jonathanelias1/embed/preview/mdLweBP?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen{" "}
              <a href="https://codepen.io/jonathanelias1/pen/mdLweBP">
                :disabled
              </a>{" "}
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: -1450, y: 3150 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",

      width: 500,
    },
  },

  {
    id: "6",

    data: {
      label: (
        <>
          <strong>:first-child & :first-of-type</strong>
          <p>
            :first-child = Used to select the specified selector, only if it is
            the first child of its parent.
            <br /> <br />
            :first-of-type = Matches every element that is the first child, of a
            particular type, of its parent. This is the same as :nth-of-type(1)
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":empty"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmLpBY?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmLpBY">:empty</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -314, y: 2200 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",

      width: 500,
    },
  },

  {
    id: "7",

    data: {
      label: (
        <>
          <strong>:focus</strong>
          <p>Used to select the element that has focus.</p>
          <p>
            <iframe
              height="300"
              width="100%"
              scrolling="no"
              title=":first-child"
              src="https://codepen.io/jonathanelias1/embed/preview/mdLwevR?default-tab=result&editable=true"
              frameBorder="no"
              loading="lazy"
              allowtransparency="true"
              allowFullScreen={true}
            >
              See the Pen
              <a href="https://codepen.io/jonathanelias1/pen/mdLwevR">
                :first-child
              </a>
              by Jonathan Elias (
              <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>)
              on <a href="https://codepen.io">CodePen</a>.
            </iframe>
          </p>
        </>
      ),
    },
    position: { x: 2926, y: 1609 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "8",

    data: {
      label: (
        <>
          <strong>:hover</strong>
          <p>Used to style elements when you mouse over them.</p>

          <p>
            Note: :hover MUST come after :link and :visited (if they are
            present)
          </p>

          <p className="hoveritem1">This will turn yellow on hover</p>
        </>
      ),
    },
    position: { x: 2589, y: 1120 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "9",

    data: {
      label: (
        <>
          <strong>:in-range & :out-of-range</strong>
          <p>
            :in-range = Selects all elements with a value that is within a
            specified range.
            <br />
            <br />
            :out-of-range = Selects all elements with a value that is outside a
            specified range.
            <br />
            <br />
            Note: These only work for input elements with min and/or max
            attributes!
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":focus"
            src="https://codepen.io/jonathanelias1/embed/preview/ExLXVzq?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/ExLXVzq">:focus</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 988, y: 2366 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "10",

    data: {
      label: (
        <>
          <strong>:valid & :invalid</strong>
          <p>
            :valid = selects form elements with a value that validates according
            to the element's settings.
            <br />
            <br />
            :invalid = selects form elements with a value that does not validate
            according to the element's settings.
            <br />
            <br />
            Note: These selectors only work for form elements with limitations,
            such as input elements with min and max attributes, email fields
            without a legal email, or number fields without a numeric value,
            etc.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":in-range &amp; :out-of-range"
            src="https://codepen.io/jonathanelias1/embed/preview/gOzRPmv?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/gOzRPmv">
              :in-range &amp; :out-of-range
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 366, y: 2366 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "11",

    data: {
      label: (
        <>
          <strong>:lang(language)</strong>
          <p>
            Used to select elements with a lang attribute with the specified
            value.
            <br /> <br />
            Note: The lang attribute value is most often a two-letter language
            code, like lang="fr" (for French), or two language codes combined,
            like lang="fr-ca" (for Canadian French).
          </p>
          <p className="lang-it">
            The paragraph below has a class of it which is italian. So the CSS
            would look like this:{" "}
          </p>

          <p lang="it">
            This paragraph will have a yellow font since its language (aka lang)
            property is equal to "it".
            <br />
            <br />
            HTML: {`<p lang="it"> Content goes here </p>`}
            <br />
            <br />
            CSS:{" "}
            {`p:lang(it){
  color: yellow
}`}
          </p>
        </>
      ),
    },
    position: { x: -2865, y: 1018 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "12",

    data: {
      label: (
        <>
          <strong>:last-child aka :nth-last-child & :last-of-type</strong>
          <p>
            :last-child = Matches every element that is the last child of its
            parent.
            <br />
            <br />
            Note: p:last-child is equal to p:nth-last-child(1).
          </p>

          <p>
            {" "}
            :last-of-type = Matches every element that is the last child, of a
            particular type, of its parent. <br />
            <br />
            Note: p:last-of-type is equal to p:nth-last-of-type(1).
          </p>

          <iframe
            height="300"
            width="100%"
            scrolling="no"
            title=":valid &amp; :invalid"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmLJmx?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmLJmx">
              :valid &amp; :invalid
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1983, y: 2200 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "13",

    data: {
      label: (
        <>
          <strong>:link</strong>
          <p>
            Used to select unvisited links.
            <br />
            <br />
            Note: The :link selector does not style links you have already
            visited.
          </p>

          <p href="example.com" className="link-example-4">
            Google.com
          </p>
        </>
      ),
    },
    position: { x: 1553, y: 1119 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "14",

    data: {
      label: (
        <>
          <strong>:not(selector)</strong>
          <p>
            Matches every element that is NOT the specified element/selector.
          </p>

          <iframe
            height="650"
            width="100%"
            scrolling="no"
            title=":last-child"
            src="https://codepen.io/jonathanelias1/embed/preview/vYjZzqd?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/vYjZzqd">
              :last-child
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -4744, y: 1000 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "15",

    data: {
      label: (
        <>
          <strong>:nth-child(n)</strong>
          <p>
            The :nth-child(n) selector matches every element that is the nth
            child of its parent.
            <br />
            <br />
            n can be a number, a keyword (odd or even), or a formula (like an +
            b).
            <br />
            <br />
            Note: Look at the :nth-of-type() selector to select the element that
            is the nth child, of the same type (tag name), of its parent.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":nth(child)a"
            src="https://codepen.io/jonathanelias1/embed/preview/WNJOabq?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/WNJOabq">
              :nth(child)a
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1976, y: 1120 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "16",

    data: {
      label: (
        <>
          <strong>:nth-last-child(n)</strong>
          <p>
            Matches every element that is the nth child, regardless of type, of
            its parent, counting from the last child.
            <br />
            <br />n can be a number, a keyword, or a formula.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":nth-last-child(selector)"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjrQKJ?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjrQKJ">
              :nth-last-child(selector)
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -878, y: 2200 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "17",

    data: {
      label: (
        <>
          <strong>:nth-last-of-type(n)</strong>
          <p>
            Matches every element that is the nth child, of a particular type,
            of its parent, counting from the last child.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":nth-last-child(selector)"
            src="https://codepen.io/jonathanelias1/embed/preview/XWqgydq?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/XWqgydq">
              :nth-last-child(selector)
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1429, y: 2200 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "18",

    data: {
      label: (
        <>
          <strong>:nth-of-type(n)</strong>
          <p>
            Matches every element that is the nth child, of the same type (tag
            name), of its parent.
            <br />
            <br />n can be a number, a keyword (odd or even), or a formula (like
            an + b).
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":nth-last-of-type(n)"
            src="https://codepen.io/jonathanelias1/embed/preview/eYrRQgM?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/eYrRQgM">
              :nth-last-of-type(n)
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1434, y: 1120 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "19",

    data: {
      label: (
        <>
          <strong>:only-of-type</strong>
          <p>
            Matches every element that is the only child of its type, of its
            parent.
          </p>
          <iframe
            height="500"
            width="100%;"
            scrolling="no"
            title=":nth-of-type(n)"
            src="https://codepen.io/jonathanelias1/embed/preview/rNvwQzr?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/rNvwQzr">
              :nth-of-type(n)
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -336, y: 1120 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "20",

    data: {
      label: (
        <>
          <strong>:only-child</strong>
          <p>Matches every element that is the only child of its parent.</p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":only-of-type"
            src="https://codepen.io/jonathanelias1/embed/preview/zYjzMyb?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/zYjzMyb">
              :only-of-type
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -864, y: 1120 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "21",

    data: {
      label: (
        <>
          <strong>:optional & :required</strong>
          <p>
            :optional = Selects form elements which are optional.
            <br />
            Form elements with no required attribute are defined as optional.
            <br />
            :required = Selects form elements which are required.
            <br />
            Form elements with a required attribute are defined as required.
            <br />
            The :optional and :required selector only apply to the form
            elements: input, select and textarea.
            <br />
            Note: Use the :required selector to select form elements which are
            required.
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":only-child"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmLMpp?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmLMpp">
              :only-child
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 374, y: 1108 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "22",

    data: {
      label: (
        <>
          <strong>:read-only and :read-write</strong>
          <p>
            :read-only = Selects elements which are "readonly".
            <br />
            <br />
            Form elements with a "readonly" attribute are defined as "readonly".
            <br />
            <br />
            :read-write = Selects form elements which are "readable" and
            "writeable".
            <br />
            <br />
            Form elements with no "readonly" attribute, and no "disabled"
            attribute are defined as "read-" and "write-able".
          </p>

          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":target"
            src="https://codepen.io/jonathanelias1/embed/preview/LYmLqWe?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/LYmLqWe">:target</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 936, y: 1112 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "23",

    data: {
      label: (
        <>
          <strong>:root</strong>
          <p>
            Matches the document's root element. <br />
            <br />
            Use this to store global variables and then use the var() function
            to access them.{" "}
          </p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":optional"
            src="https://codepen.io/jonathanelias1/embed/preview/poVwqRq?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVwqRq">
              :optional
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -870, y: 3106 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "24",

    data: {
      label: (
        <>
          <strong>:target</strong>
          <p>Can be used to style the current active target element.</p>
          <iframe
            height="500"
            width="100%"
            scrolling="no"
            title=":target"
            src="https://codepen.io/jonathanelias1/embed/preview/KKRqJzK?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/KKRqJzK">:target</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1770, y: 1518 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "25",

    data: {
      label: (
        <>
          <strong>:visited</strong>
          <p>Used to style visited links.</p>

          <p>
            If you visit the link below, the next time you see it, it will be
            pink due to the following code: {`a:visited{color: pink}}`}
            <a className="visited-example-43" href="example.com">
              Example.com
            </a>
          </p>
        </>
      ),
    },
    position: { x: 2010, y: 1114 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "26",

    data: {
      label: (
        <>
          <strong>:has</strong>
          <p>
            Represents an element if any of the selectors passed as parameters
            (relative to the :scope of the given element) match at least one
            element.
          </p>

          <p>
            Previously we were only able to style down from parent to child with
            css but the :has Pseudo-class allows us to actually go back up the
            tree.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="This &lt;input&gt; :has an error message "
            src="https://codepen.io/jonathanelias1/embed/preview/YzLQBvR?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullscreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/YzLQBvR">
              This &lt;input&gt; :has an error message{" "}
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -4120, y: 1000 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "27",

    data: {
      label: (
        <>
          <strong>:is</strong>
          <p>
            Takes a selector list as its argument, and selects any element that
            can be selected by one of the selectors in that list. This is useful
            for writing large selectors in a more compact form.
          </p>

          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title=":is and :where"
            src="https://codepen.io/jonathanelias1/embed/preview/bGMrgdE?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/bGMrgdE">
              :is and :where
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -4752, y: 2080 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "28",

    data: {
      label: (
        <>
          <strong>:where</strong>
          <p>
            Takes a selector list as its argument, and selects any element that
            can be selected by one of the selectors in that list.
          </p>
          <p>
            Difference between :is and :where = :is() counts towards the
            specificity of the overall selector (it takes the specificity of its
            most specific argument), whereas :where() has a specificity value of
            0.
          </p>

          <iframe
            height="650"
            width="100%;"
            scrolling="no"
            title=":is and :where"
            src="https://codepen.io/jonathanelias1/embed/preview/qBYXrOB?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/qBYXrOB">
              :is and :where
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -3495, y: 2080 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "29",

    data: {
      label: (
        <>
          <strong>:has & :not</strong>
          <p>You can use these pseudoclasses together to style with css.</p>

          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title=":has() example three"
            src="https://codepen.io/jonathanelias1/embed/preview/abGyJyb?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/abGyJyb">
              :has() example three
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -3500, y: 1000 },
    style: {
      background: level2,
      color: black,
      border: "1px solid #222138",
      width: 500,
    },
  },

  {
    id: "30",
    data: {
      label: (
        <>
          <strong>Input pseudo-classes</strong>
          <p>
            These pseudo-classes relate to form elements, and enable selecting
            elements based on HTML attributes and the state that the field is in
            before and after interaction.
          </p>
        </>
      ),
    },
    position: { x: 520, y: 600 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  {
    id: "31",
    data: {
      label: (
        <>
          <strong>Linguistic pseudo-classes</strong>
          <p>
            These pseudo-classes reflect the document language, and enable the
            selection of elements based on language or script direction.
          </p>
        </>
      ),
    },
    position: { x: -2666, y: 580 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "32",
    data: {
      label: (
        <>
          <strong>Location pseudo-classes</strong>
          <p>
            These pseudo-classes relate to links, and to targeted elements
            within the current document.
          </p>
        </>
      ),
    },
    position: { x: 1765, y: 596 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "33",
    data: {
      label: (
        <>
          <strong>Tree-structural pseudo-classes</strong>
          <p>
            These pseudo-classes relate to the location of an element within the
            document tree.
          </p>
        </>
      ),
    },
    position: { x: -1105, y: 580 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "34",
    data: {
      label: (
        <>
          <strong>User action pseudo-classes</strong>
          <p>
            These pseudo-classes require some interaction by the user in order
            for them to apply, such as holding a mouse pointer over an element.
          </p>
        </>
      ),
    },
    position: { x: 2972, y: 634 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  {
    id: "35",
    data: {
      label: (
        <>
          <strong>Other pseudo-classes</strong>
          <p>These pseudo-classes do not fall under a specific category.</p>
        </>
      ),
    },
    position: { x: -4073, y: 615 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 400,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-30",
    source: "1",
    target: "30",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-31",
    source: "1",
    target: "31",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-32",
    source: "1",
    target: "32",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-33",
    source: "1",
    target: "33",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-34",
    source: "1",
    target: "34",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e1-35",
    source: "1",
    target: "35",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Input Pseudo classes
  {
    id: "e30-3",
    source: "30",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e30-4",
    source: "30",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e30-9",
    source: "30",
    target: "9",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e30-10",
    source: "30",
    target: "10",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e30-21",
    source: "30",
    target: "21",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e30-22",
    source: "30",
    target: "22",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Linguistic pseudo classes
  {
    id: "e31-11",
    source: "31",
    target: "11",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Location pseudo classes
  {
    id: "e32-13",
    source: "32",
    target: "13",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e32-24",
    source: "32",
    target: "24",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e32-25",
    source: "32",
    target: "25",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //tree structural pseudo classes
  {
    id: "e33-5",
    source: "33",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-6",
    source: "33",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-12",
    source: "33",
    target: "12",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-15",
    source: "33",
    target: "15",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e33-16",
    source: "33",
    target: "16",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-17",
    source: "33",
    target: "17",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-18",
    source: "33",
    target: "18",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-19",
    source: "33",
    target: "19",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-20",
    source: "33",
    target: "20",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e33-23",
    source: "33",
    target: "23",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //User action pseudo classes
  {
    id: "e34-2",
    source: "34",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e34-7",
    source: "34",
    target: "7",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e34-8",
    source: "34",
    target: "8",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Other pseudo-classes
  {
    id: "e35-14",
    source: "35",
    target: "14",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e35-26",
    source: "35",
    target: "26",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e35-27",
    source: "35",
    target: "27",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e35-28",
    source: "35",
    target: "28",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },
  {
    id: "e35-29",
    source: "35",
    target: "29",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
